// source:  https://github.com/modusign/external-document/blob/stage/src/externalDocument/application/batchManagement/validation/BatchExcelDataValidator.ts
enum CellType {
  EXCEL_ROW = 'EXCEL_ROW',
  DOCUMENT_ID = 'DOCUMENT_ID',
  DOCUMENT_REGISTRATION_NUMBER = 'DOCUMENT_REGISTRATION_NUMBER',
  DOCUMENT_TITLE = 'DOCUMENT_TITLE',
  DOCUMENT_CATEGORY_NAME = 'DOCUMENT_CATEGORY_NAME',
  DOCUMENT_DATE_OF_COMPLETION = 'DOCUMENT_DATE_OF_COMPLETION',
  DOCUMENT_DOCUMENT_PERIOD_FROM = 'DOCUMENT_DOCUMENT_PERIOD_FROM',
  DOCUMENT_DOCUMENT_PERIOD_TO = 'DOCUMENT_DOCUMENT_PERIOD_TO',
  DOCUMENT_STATUS = 'DOCUMENT_STATUS',
  DOCUMENT_TYPE = 'DOCUMENT_TYPE',
  DOCUMENT_RENEWAL_DAYS_OF_NOTICE_BEFORE_EXPIRATION = 'DOCUMENT_RENEWAL_DAYS_OF_NOTICE_BEFORE_EXPIRATION',
  DOCUMENT_RENEWAL_PERIOD = 'DOCUMENT_RENEWAL_PERIOD',
  DOCUMENT_ORIGINAL_LOCATION = 'DOCUMENT_ORIGINAL_LOCATION',
  DOCUMENT_PERSON_IN_CHARGE_NAME = 'DOCUMENT_PERSON_IN_CHARGE_NAME',
  DOCUMENT_PERSON_IN_CHARGE_PHONE_COUNTRY_CALLING_CODE = 'DOCUMENT_PERSON_IN_CHARGE_PHONE_COUNTRY_CALLING_CODE',
  DOCUMENT_PERSON_IN_CHARGE_PHONE_NUMBER = 'DOCUMENT_PERSON_IN_CHARGE_PHONE_NUMBER',
  DOCUMENT_PERSON_IN_CHARGE_EMAIL = 'DOCUMENT_PERSON_IN_CHARGE_EMAIL',
  SIGNER_TYPE = 'SIGNER_TYPE',
  SIGNER_EXTERNAL_SIGNER = 'SIGNER_EXTERNAL_SIGNER',
  SIGNER_NAME = 'SIGNER_NAME',
  SIGNER_COMPANY = 'SIGNER_COMPANY',
  SIGNER_PHONE_COUNTRY_CALLING_CODE = 'SIGNER_PHONE_COUNTRY_CALLING_CODE',
  SIGNER_PHONE_NUMBER = 'SIGNER_PHONE_NUMBER',
  SIGNER_EMAIL = 'SIGNER_EMAIL',
  SIGNER_PERSON_IN_CHARGE_NAME = 'SIGNER_PERSON_IN_CHARGE_NAME',
  SIGNER_PERSON_IN_CHARGE_PHONE_COUNTRY_CALLING_CODE = 'SIGNER_PERSON_IN_CHARGE_PHONE_COUNTRY_CALLING_CODE',
  SIGNER_PERSON_IN_CHARGE_PHONE_NUMBER = 'SIGNER_PERSON_IN_CHARGE_PHONE_NUMBER',
  SIGNER_PERSON_IN_CHARGE_EMAIL = 'SIGNER_PERSON_IN_CHARGE_EMAIL',
}

// source: https://github.com/modusign/external-document/blob/stage/src/externalDocument/application/batchManagement/validation/ValidationErrorMessage.ts
// Excel
export const EMPTY_ROWS = 'Rows are empty';

// Document Validation
const DOCUMENT_ID_IS_REQUIRED = 'Document id is required';
const DOCUMENT_ID_IS_INVALID = 'Document id is invalid';
const REGISTRATION_NUMBER_IS_REQUIRED = 'Registration number is required';
const TITLE_IS_REQUIRED = 'Title is required';
const TITLE_IS_TOO_LONG = 'Title is too long';
const CATEGORY_NAME_IS_TOO_LONG = 'Category name is too long';
const DATE_OF_COMPLETION_NOT_A_DATE = 'Date of completion must be a date';
const DATE_OF_COMPLETION_INVALID_DATE = 'Date of completion must before document period to';
const DATE_OF_COMPLETION_IS_REQUIRED = 'Date of completion is required';
const DOCUMENT_PERIOD_FROM_NOT_A_DATE = 'Document period from must be a date';
const DOCUMENT_PERIOD_FORM_INVALID_DATE = 'Document period from must before document period to';
const DOCUMENT_PERIOD_TO_NOT_A_DATE = 'Document period to must be a date';
const DOCUMENT_PERIOD_TO_INVALID_DATE = 'Document period to must after document period from';
const DOCUMENT_PERIOD_FROM_IS_REQUIRED = 'Document period from is required';
const STATUS_IS_INVALID = 'Status is invalid';
const TYPE_IS_INVALID = 'Type is invalid';
const RENEWAL_DAYS_OF_NOTICE_BEFORE_EXPIRATION_IS_INVALID =
  'Renewal days of notice before expiration is invalid';
const RENEWAL_PERIOD_IS_INVALID = 'Renewal period is invalid';
const RENEWAL_PERIOD_IS_REQUIRED = 'Renewal period is required';
const ORIGINAL_LOCATION_IS_TOO_LONG = 'Original location is too long';
const PERSON_IN_CHARGE_NAME_IS_REQUIRED = 'Person in charge name is required';
const PERSON_IN_CHARGE_NAME_IS_TOO_LONG = 'Person in charge name is too long';
const PERSON_IN_CHARGE_COUNTRY_CALLING_CODE_IS_INVALID =
  'Person in charge country calling code is invalid';
const PERSON_IN_CHARGE_COUNTRY_CALLING_CODE_IS_REQUIRED =
  'Person in charge country calling code is required';
const PERSON_IN_CHARGE_PHONE_NUMBER_AND_EMAIL_BOTH_CANNOT_EMPTY =
  'Person in charge phone number and email both cannot empty';
const PERSON_IN_CHARGE_PHONE_NUMBER_IS_REQUIRED = 'Person in charge phone number is required';
const PERSON_IN_CHARGE_PHONE_NUMBER_IS_INVALID = 'Person in charge phone number is invalid';
const PERSON_IN_CHARGE_EMAIL_IS_TOO_LONG = 'Person in charge email is too long';
const PERSON_IN_CHARGE_EMAIL_IS_INVALID = 'Person in charge email is invalid';

// Signer Validation
const SIGNER_TYPE_IS_INVALID = 'Signer type is invalid';
const SIGNER_TYPE_IS_REQUIRED = 'Signer type is required';
const EXTERNAL_SIGNER_IS_INVALID = 'External signer is invalid';
const EXTERNAL_SIGNER_IS_REQUIRED = 'External signer is required';
const SIGNER_NAME_IS_TOO_LONG = 'Signer name is too long';
const SIGNER_NAME_IS_REQUIRED = 'Signer name is required';
const COMPANY_NEED_TO_BE_EMPTY = 'Company need to be empty';
const COMPANY_IS_REQUIRED = 'Company is required';
const COMPANY_IS_TOO_LONG = 'Company is too long';
const SIGNER_COUNTRY_CALLING_CODE_IS_REQUIRED = 'Signer country calling code is required';
const SIGNER_COUNTRY_CALLING_CODE_IS_INVALID = 'Signer country calling code is invalid';
const SIGNER_PHONE_NUMBER_AND_EMAIL_BOTH_CANNOT_EMPTY =
  'Signer phone number and email both cannot empty';
const SIGNER_PHONE_NUMBER_IS_REQUIRED = 'Signer phone number is required';
const SIGNER_PHONE_NUMBER_IS_INVALID = 'Signer phone number is invalid';
const SIGNER_EMAIL_IS_TOO_LONG = 'Signer email is too long';
const SIGNER_EMAIL_IS_INVALID = 'Signer email is invalid';
const SIGNER_PERSON_IN_CHARGE_NAME_NEED_TO_BE_EMPTY =
  "Signer's person in charge name need to be empty";
const SIGNER_PERSON_IN_CHARGE_NAME_IS_REQUIRED = "Signer's person in charge name is required";
const SIGNER_PERSON_IN_CHARGE_NAME_IS_TOO_LONG = "Signer's person in charge name is too long";
const SIGNER_PERSON_IN_CHARGE_PHONE_COUNTRY_CALLING_CODE_NEED_TO_BE_EMPTY =
  "Signer's person in charge phone country calling code need to be empty";
const SIGNER_PERSON_IN_CHARGE_PHONE_COUNTRY_CALLING_CODE_IS_REQUIRED =
  "Signer's person in charge phone country calling code is required";
const SIGNER_PERSON_IN_CHARGE_PHONE_COUNTRY_CALLING_CODE_IS_INVALID =
  "Signer's person in charge phone country calling code is invalid";
const SIGNER_PERSON_IN_CHARGE_PHONE_NUMBER_NEED_TO_BE_EMPTY =
  "Signer's person in charge phone number need to be empty";
const SIGNER_PERSON_IN_CHARGE_PHONE_NUMBER_AND_EMAIL_BOTH_CANNOT_EMPTY =
  "Signer's person in charge phone number and email both cannot empty";
const SIGNER_PERSON_IN_CHARGE_PHONE_NUMBER_IS_REQUIRED =
  "Signer's person in charge phone number is required";
const SIGNER_PERSON_IN_CHARGE_PHONE_NUMBER_IS_INVALID =
  "Signer's person in charge phone number is invalid";
const SIGNER_PERSON_IN_CHARGE_EMAIL_NEED_TO_BE_EMPTY =
  "Signer's person in charge email need to be empty";
const SIGNER_PERSON_IN_CHARGE_EMAIL_IS_TOO_LONG = "Signer's person in charge email is too long";
const SIGNER_PERSON_IN_CHARGE_EMAIL_IS_INVALID = "Signer's person in charge email is invalid";

export function translateExcelValidationError(msg: string): string {
  switch (msg) {
    case EMPTY_ROWS:
      return '엑셀 행이 비어있습니다.';
    case DOCUMENT_ID_IS_REQUIRED:
      return '문서 ID는 필수입니다.';
    case DOCUMENT_ID_IS_INVALID:
      return '유효하지 않은 문서 ID입니다.';
    case REGISTRATION_NUMBER_IS_REQUIRED:
      return '등록번호는 필수입니다.';
    case TITLE_IS_REQUIRED:
      return '계약 제목은 필수입니다.';
    case TITLE_IS_TOO_LONG:
      return '계약 제목이 너무 깁니다.';
    case CATEGORY_NAME_IS_TOO_LONG:
      return '계약 유형 이름이 너무 깁니다.';
    case DATE_OF_COMPLETION_NOT_A_DATE:
      return '계약 체결일 형식이 유효하지 않습니다.';
    case DATE_OF_COMPLETION_INVALID_DATE:
      return '계약 체결일은 계약 종료일 이전이어야합니다.';
    case DATE_OF_COMPLETION_IS_REQUIRED:
      return '계약 갱신 주기가 있을 때 계약 체결일은 필수값입니다.';
    case DOCUMENT_PERIOD_FROM_NOT_A_DATE:
      return '계약 시작일 형식이 유효하지 않습니다.';
    case DOCUMENT_PERIOD_FORM_INVALID_DATE:
      return '계약 시작일은 계약 종료일 이전이어야합니다.';
    case DOCUMENT_PERIOD_TO_NOT_A_DATE:
      return '계약 종료일 형식이 유효하지 않습니다.';
    case DOCUMENT_PERIOD_TO_INVALID_DATE:
      return '계약 종료일은 계약 시작일 이후여야합니다.';
    case DOCUMENT_PERIOD_FROM_IS_REQUIRED:
      return '계약 시작일은 필수입니다.';
    case STATUS_IS_INVALID:
      return '계약 상태가 유효하지 않습니다.';
    case TYPE_IS_INVALID:
      return '계약 유형이 유효하지 않습니다.';
    case RENEWAL_DAYS_OF_NOTICE_BEFORE_EXPIRATION_IS_INVALID:
      return '계약 종료일 기준 통지일이 유효하지 않습니다.';
    case RENEWAL_PERIOD_IS_INVALID:
      return '계약 갱신 주기가 유효하지 않습니다.';
    case RENEWAL_PERIOD_IS_REQUIRED:
      return '계약 갱신 주기는 필수입니다.';
    case ORIGINAL_LOCATION_IS_TOO_LONG:
      return '원본 보관 위치가 너무 깁니다.';
    case PERSON_IN_CHARGE_NAME_IS_REQUIRED:
      return '담당자 이름은 필수입니다.';
    case PERSON_IN_CHARGE_NAME_IS_TOO_LONG:
      return '담당자 이름이 너무 깁니다.';
    case PERSON_IN_CHARGE_COUNTRY_CALLING_CODE_IS_INVALID:
      return '담당자 핸드폰의 국가 코드가 유효하지 않습니다.';
    case PERSON_IN_CHARGE_COUNTRY_CALLING_CODE_IS_REQUIRED:
      return '담당자 핸드폰의 국가 코드는 필수입니다.';
    case PERSON_IN_CHARGE_PHONE_NUMBER_AND_EMAIL_BOTH_CANNOT_EMPTY:
      return '담당자 이메일 또는 전화 번호 중 최소 하나가 필수입니다.';
    case PERSON_IN_CHARGE_PHONE_NUMBER_IS_REQUIRED:
      return '담당자 전화 번호는 필수입니다.';
    case PERSON_IN_CHARGE_PHONE_NUMBER_IS_INVALID:
      return '담당자 전화 번호가 유효하지 않습니다.';
    case PERSON_IN_CHARGE_EMAIL_IS_TOO_LONG:
      return '담당자 이메일이 너무 깁니다.';
    case PERSON_IN_CHARGE_EMAIL_IS_INVALID:
      return '담당자 이메일이 유효하지 않습니다.';
    case SIGNER_TYPE_IS_INVALID:
      return '서명자 유형이 유효하지 않습니다.';
    case SIGNER_TYPE_IS_REQUIRED:
      return '서명자 유형은 필수입니다.';
    case EXTERNAL_SIGNER_IS_INVALID:
      return '서명자 측이 유효하지 않습니다.';
    case EXTERNAL_SIGNER_IS_REQUIRED:
      return '서명자 측은 필수입니다.';
    case SIGNER_NAME_IS_TOO_LONG:
      return '서명자 이름이 너무 깁니다.';
    case SIGNER_NAME_IS_REQUIRED:
      return '서명자 이름은 필수입니다.';
    case COMPANY_NEED_TO_BE_EMPTY:
      return '개인 서명자의 경우 회사명은 비어있어야합니다.';
    case COMPANY_IS_REQUIRED:
      return '회사 서명자의 경우 회사명은 필수입니다.';
    case COMPANY_IS_TOO_LONG:
      return '회사명이 너무 깁니다.';
    case SIGNER_COUNTRY_CALLING_CODE_IS_REQUIRED:
      return '서명자 핸드폰의 국가 코드는 필수입니다.';
    case SIGNER_COUNTRY_CALLING_CODE_IS_INVALID:
      return '서명자 핸드폰의 국가 코드가 유효하지 않습니다.';
    case SIGNER_PHONE_NUMBER_AND_EMAIL_BOTH_CANNOT_EMPTY:
      return '서명자 이메일 또는 전화 번호 중 최소 하나가 필수입니다.';
    case SIGNER_PHONE_NUMBER_IS_REQUIRED:
      return '서명자 전화 번호는 필수입니다.';
    case SIGNER_PHONE_NUMBER_IS_INVALID:
      return '서명자 전화 번호가 유효하지 않습니다.';
    case SIGNER_EMAIL_IS_TOO_LONG:
      return '서명자 이메일이 너무 깁니다.';
    case SIGNER_EMAIL_IS_INVALID:
      return '서명자 이메일이 유효하지 않습니다.';
    case SIGNER_PERSON_IN_CHARGE_NAME_NEED_TO_BE_EMPTY:
      return '개인 서명자의 경우 담당자 이름는 비어있어야합니다.';
    case SIGNER_PERSON_IN_CHARGE_NAME_IS_REQUIRED:
      return '서명자의 담당자 이름은 필수입니다.';
    case SIGNER_PERSON_IN_CHARGE_NAME_IS_TOO_LONG:
      return '서명자의 담당자 이름이 너무 깁니다.';
    case SIGNER_PERSON_IN_CHARGE_PHONE_COUNTRY_CALLING_CODE_NEED_TO_BE_EMPTY:
      return '개인 서명자의 경우 담당자 전화 번호 국가코드가 비어있어야합니다.';
    case SIGNER_PERSON_IN_CHARGE_PHONE_COUNTRY_CALLING_CODE_IS_REQUIRED:
      return '서명자의 담당자 전화 번호 국가코드는 필수입니다.';
    case SIGNER_PERSON_IN_CHARGE_PHONE_COUNTRY_CALLING_CODE_IS_INVALID:
      return '서명자의 담당자 전화 번호 국가코드가 유효하지 않습니다.';
    case SIGNER_PERSON_IN_CHARGE_PHONE_NUMBER_NEED_TO_BE_EMPTY:
      return '개인 서명자의 경우 담당자 전화 번호가 비어있어야합니다.';
    case SIGNER_PERSON_IN_CHARGE_PHONE_NUMBER_AND_EMAIL_BOTH_CANNOT_EMPTY:
      return '서명자의 담당자 이메일 또는 전화 번호 중 최소 하나가 필수입니다.';
    case SIGNER_PERSON_IN_CHARGE_PHONE_NUMBER_IS_REQUIRED:
      return '서명자의 담당자 전화 번호는 필수입니다.';
    case SIGNER_PERSON_IN_CHARGE_PHONE_NUMBER_IS_INVALID:
      return '서명자의 담당자 전화 번호가 유효하지 않습니다.';
    case SIGNER_PERSON_IN_CHARGE_EMAIL_NEED_TO_BE_EMPTY:
      return '개인 서명자의 경우 담당자 이메일은 비어있어야합니다.';
    case SIGNER_PERSON_IN_CHARGE_EMAIL_IS_TOO_LONG:
      return '서명자의 담당자 이메일이 너무 깁니다.';
    case SIGNER_PERSON_IN_CHARGE_EMAIL_IS_INVALID:
      return '서명자의 담당자 이메일이 유효하지 않습니다.';
    default:
      return msg;
  }
}

export function translateCellType(type: string): string {
  switch (type) {
    case CellType.EXCEL_ROW:
      return '엑셀 행';
    case CellType.DOCUMENT_ID:
      return '문서 ID';
    case CellType.DOCUMENT_REGISTRATION_NUMBER:
      return '등록 번호';
    case CellType.DOCUMENT_TITLE:
      return '문서 제목';
    case CellType.DOCUMENT_CATEGORY_NAME:
      return '문서 유형';
    case CellType.DOCUMENT_DATE_OF_COMPLETION:
      return '계약 체결일';
    case CellType.DOCUMENT_DOCUMENT_PERIOD_FROM:
    case CellType.DOCUMENT_DOCUMENT_PERIOD_TO:
      return '계약 기간';
    case CellType.DOCUMENT_STATUS:
      return '계약 상태';
    case CellType.DOCUMENT_TYPE:
      return '계약서 형태 ';
    case CellType.DOCUMENT_RENEWAL_DAYS_OF_NOTICE_BEFORE_EXPIRATION:
      return '계약 종료일 기준 통지일';
    case CellType.DOCUMENT_RENEWAL_PERIOD:
      return '갱신 주기';
    case CellType.DOCUMENT_ORIGINAL_LOCATION:
      return '원본 보관 위치';
    case CellType.DOCUMENT_PERSON_IN_CHARGE_NAME:
    case CellType.DOCUMENT_PERSON_IN_CHARGE_PHONE_COUNTRY_CALLING_CODE:
    case CellType.DOCUMENT_PERSON_IN_CHARGE_PHONE_NUMBER:
    case CellType.DOCUMENT_PERSON_IN_CHARGE_EMAIL:
      return '담당자';
    case CellType.SIGNER_TYPE:
    case CellType.SIGNER_EXTERNAL_SIGNER:
    case CellType.SIGNER_NAME:
    case CellType.SIGNER_COMPANY:
    case CellType.SIGNER_PHONE_COUNTRY_CALLING_CODE:
    case CellType.SIGNER_PHONE_NUMBER:
    case CellType.SIGNER_EMAIL:
    case CellType.SIGNER_PERSON_IN_CHARGE_NAME:
    case CellType.SIGNER_PERSON_IN_CHARGE_PHONE_COUNTRY_CALLING_CODE:
    case CellType.SIGNER_PERSON_IN_CHARGE_PHONE_NUMBER:
    case CellType.SIGNER_PERSON_IN_CHARGE_EMAIL:
      return '서명자';
    default:
      return type;
  }
}
